export const baseUrl = process.env.REACT_APP_BASE_URL;
// export const baseUrl = "http://192.168.2.120:8000/";
// export const baseUrl = "https://api.atmanirbharfins.com/";



//* Courses
export const getCourseListUrl = baseUrl + "api/course/course-list";
export const getCourseDetailsUrl = (courseId) => baseUrl + `api/course/course-details/${courseId}`;
export const getAllCourseModulesUrl = (courseId) => baseUrl + `api/course/course-module-list/${courseId}`;

//* Category
export const getCategoryUrl = baseUrl + "api/category";
export const getAllSubCategoriesUrl = baseUrl + "api/sub-category/get-all-sub-categories";

// * Products
export const getProductByCategoryUrl = baseUrl + "api/product/get-products-by-category-id";

//* User
export const getAdvisorProfileUrl = baseUrl + "api/advisor/advisor-profile-details";

//* Leads
export const getAdvisorLeadsUrl = baseUrl + "api/lead/lead-list-for-advisor";
export const addNewLead = baseUrl + "api/lead/add-lead"
export const sendOtpToLeadMobile = baseUrl + "api/lead/lead-mobile-send-otp"
export const verifyOtpToLeadMobile = baseUrl + "api/lead/lead-mobile-verify"
export const sendOtpToLeadEmail = baseUrl + "api/lead/lead-email-send-otp"
export const verifyOtpToLeadEmail = baseUrl + "api/lead/lead-email-verify"

// * Advisor
export const sendMobileOtp = baseUrl + "api/advisor/advisor-mobile-send-otp";
export const sendEmailOtp = baseUrl + "api/advisor/advisor-email-send-otp"
export const advisorRegistration = baseUrl + "api/advisor/advisor-registration";
export const advisorReSubmitUrl = baseUrl + "api/advisor/resubmit-advisor-registration";

// * Common
export const getStateWithCityUrl = baseUrl + "api/common/get-state-with-city";


// ! Below are the API Endpoints to be deleted
// User
export const userUrl = baseUrl + "api/user/";
export const userRefreshUrl = userUrl + "auth/refresh";
export const getUserProfileUrl = userUrl + "user-profile";

// Auth
export const loginUrl = userUrl + "auth/login";

// Common
export const commonUrl = baseUrl + "api/common";

// Company
export const getAllCompaniesUrl = baseUrl + "api/company/company-list";
export const createCompanyUrl = baseUrl + "api/company/create-company";

// Category
export const addAllCategoriesUrl = baseUrl + "api/category";
export const getSubCategoriesByIdUrl = baseUrl + "api/sub-category/get-sub-categories-by-category";
export const addSubCategories = baseUrl + "api/sub-category/";
export const getCategoriesWithSubCategoriesUrl = baseUrl + "api/category/get-categories-with-sub-categories";
export const getSubCategoriesByCategoryId = (id) => baseUrl + "/api/sub-category/get-sub-categories-by-category/" + id;

// regions
export const getAllStatesUrl = baseUrl + "api/state";
export const getCompanyRegionsUrl = baseUrl + "api/region";
export const addRegionUrl = baseUrl + "api/region/add-region";
export const getRegionsList = baseUrl + "api/region/get-region-list-by-company-id"
export const deleteRegionUrl = baseUrl + "api/region/delete-region"
export const updateRegion = baseUrl + "api/region/update-region"
export const checkRegion = baseUrl + "api/region/check-region"
export const checkRM = baseUrl + "api/relationship-manager/check-relationship-manager"






//Products
export const addProductUrl = baseUrl + "api/product/add-product";
export const allProductUrl = baseUrl + "api/product/get-products-by-category-id";
export const deleteProductUrl = baseUrl + "api/product/delete-product";
export const updateProductUrl = baseUrl + "api/product/update-product";
export const getProductListByCompanyIdUrl = (companyId) => baseUrl + `api/product/get-product-list-by-company-id/${companyId}`;
export const getProductByProductIdUrl = (productid) => baseUrl + `api/product/get-product-by-product-id/${productid}`;

export const getProductByProductId = (productId) => baseUrl + `api/product/get-product-by-product-id/${productId}`;
export const getProductsByCategoryId = baseUrl + "api/product/get-products-by-category-id"







//Relationship manager
export const addRMUrl = baseUrl + "api/relationship-manager/add-relationship-manager";
export const assignRMToLead = baseUrl + "api/relationship-manager/assign-relationship-manager-to-lead"
export const allRM = baseUrl + "api/lead/lead-list";
export const getRMList = baseUrl + "api/relationship-manager/get-relationship-manager-list-by-company-id"
export const deleteRM = baseUrl + "api/relationship-manager/delete-relationship-manager"
export const updateRMUrl = baseUrl + "api/relationship-manager/update-relationship-manager"


//Leads
export const leadStatsUrl = baseUrl + "api/lead/lead-statistics-number";
export const allLeadsUrl = baseUrl + "api/lead/lead-list";
export const getLeadDetailsUrl = baseUrl + "api/lead/lead-details-by-lpr-id"



// Advisors
export const allApprovedAdvisors = baseUrl + "api/advisor/advisor-list";
export const getInvoiceList = baseUrl + "api/remuneration/invoice/get-advisor-invoice";
export const getInvoiceById = (invoice_display_id) =>
    `${baseUrl}api/remuneration/get-invoice-details-by-display-id/${invoice_display_id}`;
export const viewInvoice = (invoice_display_id) =>
    `${baseUrl}view/invoice/get-invoice-view/${invoice_display_id}`;

export const approveInvoice = baseUrl + "api/remuneration/invoice/approve-invoice";
export const rejectInvoice = baseUrl + "api/remuneration/invoice/reject-invoice";

export const remenurationCompanyFinanceUrl = baseUrl + "api/remuneration/get-remuneration-company-with-financial-statistics"
export const advisorleadDataUrl = baseUrl + "api/lead/lead-list-product-by-advisor-id"
export const verifyMobileOtp = baseUrl + "api/advisor/advisor-mobile-verify";
export const verifyEmailOtp = baseUrl + "api/advisor/advisor-email-verify";

//config
export const getmobileBannerConfig = baseUrl + "api/config/mobile-banner/get-config?is_active=true"
export const postmobileBannerConfig = baseUrl + "api/config/mobile-banner/insert-config"
export const leadCompanyUrl = baseUrl + "api/company/get-converted-lead-list-by-company-id"
export const deleteBanner = baseUrl + "api/config/mobile-banner/delete-config/{id}";
export const updateTermsAndCondition = baseUrl + "api/common/update-term-and-condition";
export const getTermsAndConditions = baseUrl + "api/common/get-term-and-condition";
export const getHelpCenter = baseUrl + "api/common/get-help-center";
export const updateHelpCenter = baseUrl + "api/common/update-help-center"

//LMS
export const createNewCourse = baseUrl + "api/course/create-course";
export const createCourseModule = baseUrl + "api/course/add-course-module"


export const deleteCourse = baseUrl + "api/course/delete-course";
export const updateCourse = baseUrl + "api/course/update-course";
export const updateCourseModule = baseUrl + "api/course/update-course-module";



// Remuneration
export const leadStatusExcelUploadUrl = baseUrl + 'api/issuance/before-issuance/insert-excel-data'
export const leadCommissionExcelUploadUrl = baseUrl + 'api/issuance/after-issuance/insert-excel-data'
export const getInvoiceListForAdmin = baseUrl + "api/remuneration/get-remuneration-invoice-list-for-admin"
export const getremunerationPaymentList = baseUrl + "api/remuneration/get-remuneration-payment-list";
export const getInvoiceDetails = (invoice_display_id) => `${baseUrl}api/remuneration/get-invoice-details-by-display-id/${invoice_display_id}`;


// Scheduler config 
export const AddSchedularConfig = baseUrl + "api/config/invoice-scheduler/insert-config"
export const UpdateSchedularConfig = baseUrl + "api/config/invoice-scheduler/update-config"
export const DeleteSchedularConfig = baseUrl + "api/config/invoice-scheduler/delete-config"
export const GetSchedularConfig = baseUrl + "api/config/invoice-scheduler/get-config"

// Invoice Config
export const AddInvoiceTemplate = baseUrl + "api/config/invoice-config/invoice-template-generation"
export const UpdateInvoiceTemplate = baseUrl + "api/config/invoice-config/update-invoice-template-generation"
export const GetInvoiceTemplates = baseUrl + "api/config/invoice-config/get-invoice-template-generation"
export const UpdateInvoiceTemplateLogo = baseUrl + "api/config/invoice-config/upload-invoice-template-generation-logo"
// export const GetInvoiceTemplate = baseUrl + "view/invoice/get-invoice-view/{invoice_display_id}"

//Invoice
export const viewInvoiceDocument = (invoice_display_id) => `${baseUrl}view/invoice/get-invoice-view/${invoice_display_id}`;


//   Issuance
export const getAllExcelData = baseUrl + "api/issuance/after-issuance/get-excel-data-for-after-issuance"

//* Support Chat
export const openSupportConversationUrl = baseUrl + "api/support/conversation";
export const getMySupportConversationsUrl = baseUrl + "api/support/my-conversations";
export const getSupportMessagesUrl = (conversationId) =>
  baseUrl + `api/support/conversation/${conversationId}/messages`;
export const sendSupportMessageUrl = baseUrl + "api/support/message";
export const markSupportReadUrl = (conversationId) =>
  baseUrl + `api/support/conversation/${conversationId}/read`;

//* Pro Subscription / Payments
export const getPlansUrl = baseUrl + "api/payment/plans";
export const getMySubscriptionUrl = baseUrl + "api/payment/my-subscription";
export const createPaymentOrderUrl = baseUrl + "api/payment/create-order";
export const verifyPaymentUrl = baseUrl + "api/payment/verify";

//* Certification
export const getCertificationExamsUrl = baseUrl + "api/certification/exams";
export const getCertificationExamUrl = (id) => baseUrl + `api/certification/exam/${id}`;
export const submitCertificationExamUrl = (id) =>
  baseUrl + `api/certification/exam/${id}/submit`;
export const getMyAttemptsUrl = baseUrl + "api/certification/my-attempts";
export const getMyCertificatesUrl = baseUrl + "api/certification/my-certificates";

//* Home / Onboarding
export const onboardingProgressUrl = baseUrl + "api/home/onboarding-progress";

//* Notification Center
export const notifListUrl = baseUrl + "api/notification-center/list";
export const notifUnreadCountUrl = baseUrl + "api/notification-center/unread-count";
export const notifMarkReadUrl = (id) => baseUrl + `api/notification-center/${id}/read`;
export const notifMarkAllReadUrl = baseUrl + "api/notification-center/read-all";
export const notifPreferencesUrl = baseUrl + "api/notification-center/preferences";

//* Lead Engagement (stages, timeline, tasks)
export const leadStatusesUrl = baseUrl + "api/lead-engagement/statuses";
export const prioritizedLeadsUrl = baseUrl + "api/lead-engagement/prioritized-leads";
export const leadStageUrl = (lprId) => baseUrl + `api/lead-engagement/${lprId}/stage`;
export const leadNoteUrl = (lprId) => baseUrl + `api/lead-engagement/${lprId}/note`;
export const leadTimelineUrl = (lprId) => baseUrl + `api/lead-engagement/${lprId}/timeline`;
export const leadTasksForLeadUrl = (lprId) => baseUrl + `api/lead-engagement/${lprId}/tasks`;
export const createLeadTaskUrl = baseUrl + "api/lead-engagement/task";
export const myTasksUrl = baseUrl + "api/lead-engagement/tasks";
export const completeTaskUrl = (id) => baseUrl + `api/lead-engagement/task/${id}/complete`;
export const cancelTaskUrl = (id) => baseUrl + `api/lead-engagement/task/${id}/cancel`;

//* Referral / Gamification
export const getMyReferralCodeUrl = baseUrl + "api/referral/my-code";
export const createReferralUrl = baseUrl + "api/referral/create";
export const getMyReferralsUrl = baseUrl + "api/referral/my-referrals";
export const getMyRewardsUrl = baseUrl + "api/referral/my-rewards";
export const getMyStatsUrl = baseUrl + "api/referral/my-stats";
export const getLeaderboardUrl = baseUrl + "api/referral/leaderboard";

